import { httpClient } from "src/shared/services/httpClient";

export const getCreditCardFormParams = (
  mode: string,
  id?: string | null,
  year?: string,
  finePaymentId?: number,
) => {
  const isViolation = mode === "violationCase";
  return httpClient.get(
    `creditCard/cardForm?mode=${mode}${
      isViolation && finePaymentId
        ? `&finePaymentId=${finePaymentId}`
        : id
          ? `&${isViolation ? "caseId" : "appId"}=${id}`
          : ""
    }${year ? `&year=${year}` : ""}`,
  );
};

export const getCountrySubdivision = (countryNumericCode: string) =>
  httpClient.get(
    `creditCard/getCountrySubdivision?countryNumericCode=${countryNumericCode}`,
  );

export const getCountryPhoneCode = (countryNumericCode: string) =>
  httpClient.get(
    `creditCard/getCountryPhoneCode?countryNumericCode=${countryNumericCode}`,
  );

export const cardProcess = (formData: any) =>
  httpClient.post(`creditCard/cardProcess`, formData);

export const getMerchantNotificationAfterRenderJSON = (
  merchantReference: string,
) =>
  httpClient.get(
    `creditCard/getMerchantNotificationAfterRenderJSON?merchantReference=${merchantReference}`,
  );

export const getTDSHandleContinue = (merchantReference: string) =>
  httpClient.get(
    `creditCard/tdsHandleContinue?merchantReference=${merchantReference}`,
  );

export const getParesResult = (merchantReference: string) =>
  httpClient.get(
    `creditCard/getParesResult?merchantReference=${merchantReference}`,
  );

export const tdsCompletePares = (merchantReference: string) =>
  httpClient.get(
    `creditCard/tdsCompletePares?merchantReference=${merchantReference}`,
  );

export const successReact = () => httpClient.get(`creditCard/successReact`);
